/*******
Common Function Used In Diamond Listing & Detail Page 
********/

/*** Pre Define Constant Values For Webservice Call ***/
const api = "https://py.diamondculture.com.hk/live/graphql/";
const rapnetDiamondListingApi = "rapnetDiamondData";
const labDiamondListingApi = "diamondData";
const rapnetDiamondDetailApi = "rapnetDiamondById";
const labDiamondDetailApi = "diamondById";
const diamondSearchByReportApi = "devDiamondByStockorcert";
const rapnetDiamondAddToCart = "rapnetDiamondAddToCart";
const labDiamondAddToCart = "diamondAddToCart";
/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

/*** AddCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** Get Certificate File URL Start ***/
function getCertificateUrl(diamondData) {
  var certificateFile = '';
  var diaLab = diamondData.lab;
  var diaCertNo = diamondData.certificateNumber;
  var diaCarat = diamondData.caratWeight;
  
  if(diamondData.certificateFile != ''){
    certificateFile = diamondData.certificateFile;
  }else{
    switch(diaLab)
      {
        case "GIA":
            certificateFile = 'https://www.gia.edu/cs/Satellite?reportno='+diaCertNo+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
            break;
        case "IGI":
            certificateFile = 'https://www.igi.org/verify-your-report/?r='+diaCertNo;
            break;
        case "HRD":
            certificateFile = 'https://my.hrdantwerp.com/?record_number='+diaCertNo+'&weight='+diaCarat;
            break;
        case "AGS":
            certificateFile = 'https://www.agslab.com/reportTypes/pdqr.php?StoneID='+diaCertNo+'&Weight='+diaCarat+'&D=1';
            break;
        default:
            certificateFile = "";
      }
  }    
  return certificateFile;
}
/*** End ***/

/*** Diamond Broken Image Fixes start ***/ 
function imgError(image,defaultImage) {
  image.onerror = "";
  image.src = defaultImage;
  return true;
}
/*** End ***/  

/*** Get Diamond Price Start ***/
function getDiamondPrice(currencyRate,finalPrice) {  
  var final_dia_price = finalPrice; 
  var dia_formatted_price = Math.ceil(final_dia_price);      
  dia_formatted_price = Shopify.formatMoney(dia_formatted_price * 100, theme.moneyFormat);
  dia_formatted_price = dia_formatted_price.substr(0, dia_formatted_price.indexOf('.'));
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Type Start ***/
function getDiamondType(diamondType) {
  var type = diamondType;
  if(type == 'white'){
    dia_type = 'Natural';
  }else{
    dia_type = translations.diamondNameType;
  }
  return dia_type;
}
/*** End ***/

/*** Get Diamond Name Start ***/
function getDiamondName(diamondData,diamondType) {
  if(jQuery(window).width() <= 767){
    var diamond_name = diamondData.caratWeight + " "+translations.diamondNameCaratCt+" " + diamondData.shape + " "+ diamondType +" "+translations.diamondNameDiamond;
  }else{
  var diamond_name = diamondData.caratWeight + " "+translations.diamondNameCarat+" " + diamondData.shape + " "+ diamondType +" "+translations.diamondNameDiamond;
  }
  return diamond_name;
}
/*** End ***/

/*** Get Diamond measurement Start ***/
function getDiamondMeasurement(diamondData) {
  if(diamondData.measurement != ''){
    var measurements = diamondData.measurement;
  }else{
    var measurements = diamondData.length + " * " + diamondData.width + " * " + diamondData.depth;
  }  
  return measurements;
}
/*** End ***/

/*** Get Diamond Girdle Start ***/
function getDiamondGirdle(diamondData) {
  if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
    var girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
  }else if(diamondData.girdleMax == '' && diamondData.girdleMax == 0){
    var girdle = diamondData.girdleMin;
  }else if(diamondData.girdleMin == '' && diamondData.girdleMax == 0){
    var girdle = diamondData.girdleMax;
  }else{
    var girdle = 'NA';
  }  
  return girdle;
}
/*** End ***/

/*** Get Diamond Detail Information Layout ***/
function getDiamondInformationLayout(diamondData) {
  var diamond_certificate_url = getCertificateUrl(diamondData);
  var diamond_measurements = getDiamondMeasurement(diamondData);
  var session_variable = jQuery("#session_variable").val();
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data!==null){
  var ViewType = session_other_data['View-Type'][0];
  //Dynamic Diamond Information Array 
  if(ViewType == 'list'){
  var diamondInformation = {
    "diamondCertificateNumber": translations.titleCertificateNumber+' - '+diamondData.certificateNumber,
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondTable"   : translations.titleTable+' - '+diamondData.tablePerc,
    "diamondCarat"   : translations.titleCaratWeight+' - '+diamondData.caratWeight,
    "diamondDepth"   : translations.titleDepth+' - '+diamondData.deptPerc,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondRatio"   : translations.titleRatio+' - '+diamondData.ratio,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,
    "diamondgirdle"  : translations.titleGirdle+' - '+diamondData.girdle,
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,
  };
  }else{
    var diamondInformation = {
    "diamondCertificateNumber": translations.titleCertificateNumber+' - '+diamondData.certificateNumber,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondCarat"   : translations.titleCaratWeight+' - '+diamondData.caratWeight,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,
    "diamondTable"   : translations.titleTable+' - '+diamondData.tablePerc,
    "diamondDepth"   : translations.titleDepth+' - '+diamondData.deptPerc,
    "diamondRatio"   : translations.titleRatio+' - '+diamondData.ratio,
    "diamondgirdle"  : translations.titleGirdle+' - '+diamondData.girdle,
  };
  }
  }else{
    var diamondInformation = {
    "diamondCertificateNumber": translations.titleCertificateNumber+' - '+diamondData.certificateNumber,
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondTable"   : translations.titleTable+' - '+diamondData.tablePerc,
    "diamondCarat"   : translations.titleCaratWeight+' - '+diamondData.caratWeight,
    "diamondDepth"   : translations.titleDepth+' - '+diamondData.deptPerc,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondRatio"   : translations.titleRatio+' - '+diamondData.ratio,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,
    "diamondgirdle"  : translations.titleGirdle+' - '+diamondData.girdle,
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,
  };
  }
  //end

  //Diamond Information HTML Layout
  var detailInfo = '';
  if(diamondInformation != ''){
     var j = 1;
     $.each(diamondInformation, function(i, diamondInfo) {
       var diamondInfoArray = diamondInfo.split(" - ");
       if(diamondInfoArray.length > 1){
         var infoLable = diamondInfoArray[0];
         var infoValue = diamondInfoArray[1];
        
         if(diamondInfoArray[1] != ''){
           if(diamondInfoArray.length == 3){
             var infoUrl = diamondInfoArray[2];
             detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info"><a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a></span></div> ';
           }else{
             if(infoValue != 'null'){
               detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info">'+infoValue+'</span></div> ';
             }             
           } 
           j++;
         }
       }        
    });
  }
  //end
  
  return detailInfo;
}
/*** End ***/

/*** Config function forpre define module url start ***/
if(store_lang == 'en'){
  var tps_config = {
	"urls": {        
        "loose_diamond": "/en/pages/natural-white-diamonds",
        "lab_diamond": "/en/pages/lab-white-diamonds",
        "loose_color_diamond": "/en/pages/natural-color-diamonds", 
        "lab_color_diamond": "/en/pages/lab-color-diamonds",
        "loose_diamond_detail": "/en/pages/loose-diamond-details",
	}
  }
}else{
  var tps_config = {
	"urls": {        
        "loose_diamond": "/pages/natural-white-diamonds",
        "lab_diamond": "/pages/lab-white-diamonds",
        "loose_color_diamond": "/pages/natural-color-diamonds", 
        "lab_color_diamond": "/pages/lab-color-diamonds",
        "loose_diamond_detail": "/pages/loose-diamond-details",
	}
  }
}
/*** End ***/

/*** Show Product Detail & Final Ring Page Loader Start ***/
function showProductLoader(galleryStyle){
  if(galleryStyle == 'grid-view'){            
    if(jQuery(window).width() <= 767){
      jQuery(".tps-loader-horizontal-thumb-slider").show();
    }else{
      jQuery(".tps-loader-"+galleryStyle).show();
    }
  }else{
    jQuery(".tps-loader-"+galleryStyle).show();
  }
}
/*** Show Product Detail & Final Ring Page Loader End ***/

/*** Remove HTML Elements In Mobile ***/
function removeHtmlElementsInMobile() {  
  jQuery('.tps-mobile-hide').remove();	
}
/*** End ***/

/*** Remove HTML Elements In Desktop ***/
function removeHtmlElementsInDesktop() {
  jQuery('.tps-desktop-hide').remove();	
}
/*** End ***/

/*******
End
********/